import { Typography } from '@mui/material'
import { FC } from 'react'

export const StratificationQUsEmptyState: FC = () => {
  return (
    <Typography color="text.secondary" variant="body2">
      No hay QUs creadas todavía. Creá QUs desde el flujo de clusterización.
    </Typography>
  )
}
